import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc' // Updated Apollo HOC importimport { withApollo } from 'react-apollo/index'
import './DriversListContainer.css'
import DriversList from './DriversList'
import { Container, Row, Col, Button, Nav, NavItem } from 'reactstrap'
import DriverListHeader from "./DriverListHeader"
import DriverActions from "./DriverActions"
import ManagePreferenceHOC from "../../Material/ManagePreferenceHOC"
import withApolloClient from "../../withApolloClient"
import { useNavigate } from "react-router-dom"

const tabs = [
    { id: "#active", name: "Active Drivers", filters: { stages: [6], orderBy: ["-in_office", "-id"] } }, { id: "#all", name: "All Drivers", filters: { orderBy: ["-in_office", "-id"] } },
]
const tableHeaders = [
    { id: "id", name: "Driver Info", sortable: true, visible: true, showInPicker: false, positonIsFixed: true },
    { id: "branch__name", name: "Branch", sortable: false, visible: true, showInPicker: true, positonIsFixed: false },
    { id: "weekly_billing_notes", name: "Billing Notes", sortable: false, visible: true, showInPicker: true, positonIsFixed: false },
    { id: "tags", name: "Tags", sortable: false, visible: true, showInPicker: true, positonIsFixed: false },
    { id: "assigned_to__name", name: "Assigned Reps", sortable: false, visible: true, showInPicker: true, positonIsFixed: false },
]

const DriversListContainer = (props) => {
    const navigate = useNavigate()
    return <DriversListContainerNavigate {...props} navigate={navigate} />
}

class DriversListContainerNavigate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: null,
            filterValues: {},
            showLoading: false,
            openModal: "",
            filtersSelected: 0,
            selectedDrivers: [],
            driverCountOnPage: 0,
            totalDriverCount: 0,
            refetchDrivers: false,
        }
    }

    setFilterValues = (filterValues) => {
        this.setState({ filterValues: filterValues || {} });
    }

    resetSelectedDrivers = () => {
        this.setState({ selectedDrivers: [] });
    }

    refetchQuery = () => {
        this.setState(prevState => ({ refetchDrivers: !prevState.refetchDrivers }));
    }

    setDriverCountOnPage = (count) => {
        this.setState({ driverCountOnPage: count });
    }

    setTotalDriverCount = (count) => {
        this.setState({ totalDriverCount: count });
    }

    setSelectedDrivers = (selectedDrivers) => {
        this.setState({ selectedDrivers });
    }

    updateOrder = (string) => {
        const currentOrder = this.state.filterValues?.orderBy || [];
        let order = [...currentOrder];
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }

        // Optimize: Only update state if order actually changed
        this.setState((prevState) => {
            const currentOrder = prevState.filterValues.orderBy || [];
            if (JSON.stringify(currentOrder) === JSON.stringify(order)) {
                return null;
            }
            return { filterValues: { ...prevState.filterValues, orderBy: order } };
        });
    }

    toggleModal = (modalName) => {
        if (this.state.openModal !== modalName) {
            this.setState({ openModal: modalName })
        } else {
            this.setState({ openModal: "" })
        }
    }

    componentDidMount() {
        if (window.location.hash && tabs.map(item => item.id).includes(window.location.hash)) {
            let tabIndex = tabs.findIndex(tab => tab.id === window.location.hash)
            this.setState({ activeTab: tabs[tabIndex].name })
        } else {
            window.location.hash = tabs[0].id
            this.setState({ activeTab: tabs[0].name })
        }
    }

    changeTab = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value !== this.state.activeTab) {
            let tabIndex = tabs.findIndex(tab => tab.name === value)
            window.location.hash = tabs[tabIndex].id
            this.setState({ [name]: value })
        }
    }

    render() {
        return (
            <Container fluid className="DriversListContainer">
                <Nav pills className="available-car-wrap">
                    {tabs.map(tab =>
                        <NavItem key={tab.id}>
                            <Button color="primary" name={"activeTab"} value={tab.name} className={this.state.activeTab === tab.name ? "active" : "inactive"} onClick={this.changeTab}>
                                {tab.name}
                            </Button>
                        </NavItem>
                    )}
                </Nav>
                <Row>
                    <Col xs={8}>
                        <DriverListHeader
                            activeTab={this.state.activeTab}
                            filterValues={this.state.filterValues}
                            setFilterValues={this.setFilterValues}
                            defaultFilters={this.state.activeTab && tabs.find(tab => tab.name === this.state.activeTab).filters}
                            resetSelectedDrivers={this.resetSelectedDrivers}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <DriverActions
                            activeTab={this.state.activeTab}
                            selectedDrivers={this.state.selectedDrivers}
                            resetSelectedDrivers={this.resetSelectedDrivers}
                            driverCountOnPage={this.state.driverCountOnPage}
                            totalDriverCount={this.state.totalDriverCount}
                            refetchQuery={this.refetchQuery}
                            currentUser={this.props.currentUser}
                            columnConfig={this.props.columnConfig}
                            preferenceType={"driver"}
                            refetchPreferences={this.props.refetchPreferences}
                            navigate={this.props?.navigate}
                            filterValues={this.state.filterValues}
                            {...this.props}
                        /></Col>
                </Row>
                <Row>
                    <Col>
                        <DriversList
                            currentUser={this.props.currentUser}
                            orderBy={this.state.filterValues && this.state.filterValues.orderBy || []}
                            updateOrder={this.updateOrder}
                            activeTab={this.state.activeTab}
                            columnConfig={this.props.columnConfig}
                            setDriverCountOnPage={this.setDriverCountOnPage}
                            setTotalDriverCount={this.setTotalDriverCount}
                            selectedDrivers={this.state.selectedDrivers}
                            setSelectedDrivers={this.setSelectedDrivers}
                            pk={this.state.filterValues && this.state.filterValues.pk ? this.state.filterValues.pk : null}
                            email={this.state.filterValues && this.state.filterValues.email ? this.state.filterValues.email : null}
                            phone={this.state.filterValues && this.state.filterValues.phone ? this.state.filterValues.phone : null}
                            minBalance={this.state.filterValues && this.state.filterValues.minBalance ? parseFloat(this.state.filterValues.minBalance) : null}
                            maxBalance={this.state.filterValues && this.state.filterValues.maxBalance ? parseFloat(this.state.filterValues.maxBalance) : null}
                            inOffice={this.state.filterValues && this.state.filterValues.inOffice !== null ? this.state.filterValues.inOffice : null}
                            isBlocked={this.state.filterValues && this.state.filterValues.isBlocked !== null ? this.state.filterValues.isBlocked : null}
                            hasBalanceWriteOff={this.state.filterValues && this.state.filterValues.hasBalanceWriteOff !== null ? this.state.filterValues.hasBalanceWriteOff : null}
                            hasPaymentPlan={this.state.filterValues && this.state.filterValues.hasPaymentPlan !== null ? this.state.filterValues.hasPaymentPlan : null}
                            hasPaymentSchedule={this.state.filterValues && this.state.filterValues.hasPaymentSchedule !== null ? this.state.filterValues.hasPaymentSchedule : null}
                            tlcLicense={this.state.filterValues && this.state.filterValues.tlcLicense ? this.state.filterValues.tlcLicense : null}
                            dmvLicense={this.state.filterValues && this.state.filterValues.dmvLicense ? this.state.filterValues.dmvLicense : null}
                            assignedTo={this.state.filterValues && this.state.filterValues.assignedTo ? this.state.filterValues.assignedTo : null}
                            tags={this.state.filterValues && this.state.filterValues.driverTags ? this.state.filterValues.driverTags : null}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            stages={this.state.filterValues && this.state.filterValues.stages ? this.state.filterValues.stages : null}
                            carStatusIn={this.state.filterValues && this.state.filterValues.carStatusIn ? this.state.filterValues.carStatusIn : null}
                            refetchDrivers={this.state.refetchDrivers}
                            setRefetchQuery={this.refetchQuery}
                            promoNames={this.state.filterValues && this.state.filterValues.promoNames != null ? this.state.filterValues.promoNames : null}
                            listingType="drivers"
                            branchIds={this.state.filterValues && this.state.filterValues.selectedBranches !== null ? this.state.filterValues.selectedBranches : null}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withApolloClient(
    ManagePreferenceHOC("driver", tableHeaders)
        (DriversListContainer))
